<div id="wizardService.agents.overview">
    <network-settings
          [parentOutput]="step.parent.output"
          [step]="step"
          [key]="'staticIp'"
          (onUpdate)="step.dataValueChange('agentNetworkSettings', $event.key, $event.value, $event.isValid)">
    </network-settings>
    <div class="separator"></div>
    <ntp-settings
          [parentOutput]="step.parent.output"
          [step]="step"
          [key]="'ntpServer'"
          (onUpdate)="step.dataValueChange('agentNtpSettings', $event.key, $event.value, $event.isValid)">
    </ntp-settings>
  </div>